export const ENUMS = {
  WorkflowBtnLabels: [
    {
      savePayloadPassKey: "Draft",
      title: "Save",
      description:
        "Save your progress of the workflow without making it executing changes.",
    },
    {
      savePayloadPassKey: "CopyWorkFlow",
      title: "Save As",
      description:
        "Create a new copy of the workflow with a different name while keeping the original unchanged.",
    },
    {
      savePayloadPassKey: "Publish",
      title: "Publish",
      description:
        "Finalize the workflow and it will ready to run as per scheduled.",
    },
    {
      savePayloadPassKey: "Publish",
      title: "Save & Publish",
      description:
        // "Save changes and make the workflow publicly accessible or available to users.",
        "Save changes and instantly publish the workflow,  it will ready to run as per scheduled.",
    },
    // {
    //   savePayloadPassKey: "suspend",
    //   title: "Suspend",
    //   description:
    //     "Pause the workflow execution, allowing it to be resumed later.",
    // },
    // {
    //   savePayloadPassKey: "resume",
    //   title: "Resume",
    //   description:
    //     "Restart a previously suspended workflow from where it left off.",
    // },
    // {
    //   savePayloadPassKey: "delete",
    //   title: "Delete",
    //   description: "Permanently remove the workflow and its associated data.",
    // },
  ],
  workflowparamsnotbindonthiskey: ["LOOP_LIST", "LOOP_TYPE", "LOOP_KEY"],
};
// # Workflow Status : run, suspend, resume, delete
// Draft: Create and edit a preliminary version of the workflow without finalizing it.
